import React from 'react';
import { Button, InputNumber } from 'antd';

const DEFAULT_PICK_POINT = {
  recordAccuracyMaxM: 15,
  tooLargeAccuracyM: 50
};

const DEFAULT_PICK_POINT_TTL_MINUTES = 30;

/** 
 * 手机选点设置表单（独立的一级子标签）
 * 包含：链接有效期 + 精度设置
 */
function PickPointSettingsPanel({
  handleSaveSystemSettings,
  updateSystemSettings,
  systemSettings
}) {
  const pick = {
    ...DEFAULT_PICK_POINT,
    ...(systemSettings.pickPointSettings || {})
  };

  const pickPointTtlMinutes = systemSettings.rescuePushSettings?.pickPointTtlMinutes || DEFAULT_PICK_POINT_TTL_MINUTES;

  const patchPickPoint = (next) => updateSystemSettings((settings) => ({
    ...settings,
    pickPointSettings: {
      ...DEFAULT_PICK_POINT,
      ...(settings.pickPointSettings || {}),
      ...next
    }
  }));

  const patchRescuePush = (next) => updateSystemSettings((settings) => ({
    ...settings,
    rescuePushSettings: {
      ...(settings.rescuePushSettings || {}),
      ...next
    }
  }));

  const handleResetDefaults = () => {
    patchPickPoint({ ...DEFAULT_PICK_POINT });
    patchRescuePush({ pickPointTtlMinutes: DEFAULT_PICK_POINT_TTL_MINUTES });
  };

  return (
    <div>
      <h3>手机选点</h3>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleSaveSystemSettings}>保存设置</Button>
        <Button
          style={{ marginLeft: 8 }}
          onClick={handleResetDefaults}
        >
          重置默认
        </Button>
      </div>
      <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
        前线手机打开选点链接后，需达到下方精度才开始连续取样三次。改动立即对后续打开的选点页生效。
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, maxWidth: 640 }}>
        <div>
          <h4>链接有效期（分钟）</h4>
          <InputNumber
            min={5}
            max={120}
            value={pickPointTtlMinutes}
            onChange={(value) => patchRescuePush({
              pickPointTtlMinutes: value || DEFAULT_PICK_POINT_TTL_MINUTES
            })}
            style={{ width: '100%' }}
          />
          <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
            生成选点链接时的默认有效期（默认 30 分钟）
          </p>
        </div>
        <div>
          <h4>开始记录精度（米）</h4>
          <InputNumber
            min={3}
            max={100}
            value={pick.recordAccuracyMaxM}
            onChange={(value) => patchPickPoint({ recordAccuracyMaxM: value || DEFAULT_PICK_POINT.recordAccuracyMaxM })}
            style={{ width: '100%' }}
          />
          <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
            定位精度小于该值才开始记录（默认 15 米）
          </p>
        </div>
        <div>
          <h4>误差过大阈值（米）</h4>
          <InputNumber
            min={10}
            max={500}
            value={pick.tooLargeAccuracyM}
            onChange={(value) => patchPickPoint({ tooLargeAccuracyM: value || DEFAULT_PICK_POINT.tooLargeAccuracyM })}
            style={{ width: '100%' }}
          />
          <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
            精度大于该值时提示「误差过大」（默认 50 米，须大于开始记录精度）
          </p>
        </div>
      </div>
      <div style={{ marginTop: 16, background: '#f5f5f5', padding: 12, borderRadius: 4, fontSize: 12 }}>
        当前：链接有效期 <strong>{pickPointTtlMinutes}</strong> 分钟，
        精度 &lt; <strong>{pick.recordAccuracyMaxM}</strong> 米开始取样，
        精度 &gt; <strong>{pick.tooLargeAccuracyM}</strong> 米提示过大。
      </div>
    </div>
  );
}

function canSeePhonePickPointSettings(shouldShowPage) {
  return !!(
    shouldShowPage?.('手机选点设置')
    || shouldShowPage?.('救援推送')
    || shouldShowPage?.('指挥系统设置')
    || shouldShowPage?.('系统设置')
  );
}

/** 管理后台 · 指挥系统设置 · 救援推送 · 手机选点（独立子标签） */
export function buildPhonePickPointTab(context) {
  const {
    shouldShowPage,
    handleSaveSystemSettings,
    updateSystemSettings,
    systemSettings
  } = context;

  if (!canSeePhonePickPointSettings(shouldShowPage)) return null;

  return {
    key: 'phone_pick_point_settings',
    label: '手机选点',
    children: (
      <PickPointSettingsPanel
        handleSaveSystemSettings={handleSaveSystemSettings}
        updateSystemSettings={updateSystemSettings}
        systemSettings={systemSettings}
      />
    )
  };
}
